module.exports = __webpack_public_path__ + "img/solid-lamp-street-circle-bolt.4ae2178a.svg";